import { Accordion, Checkbox, MultiSelect } from "@/ui";

type SelectableAccordionProps = {
  id: string;
  title: string;
  options: { label: string; value: string }[];
  selected: string[];
  disabled: boolean;
  onChange: (selected: string[]) => void;
  onSelectAll?: (checked: boolean) => void;
};

export const SelectableAccordion = ({
  disabled,
  id,
  onChange,
  onSelectAll,
  options,
  selected,
  title,
}: SelectableAccordionProps) => {
  const allSelected = (selected?.length ?? 0) === options.length;

  return (
    <Accordion key={id} title={title}>
      {/*
        A fragment left "Select all" flush against the first option: the gap in
        MultiSelect only spans its own children, not across to this sibling.
      */}
      <div className="flex flex-col gap-2">
        {disabled ? null : (
          <Checkbox
            checked={allSelected}
            id={`select-all-${id}`}
            label="Select all"
            onChange={(checked) => {
              if (onSelectAll) {
                onSelectAll(checked);

                return;
              }

              onChange(
                checked
                  ? options.map(({ label }) => {
                      return label;
                    })
                  : [],
              );
            }}
          />
        )}

        <MultiSelect disabled={disabled} onChange={onChange} options={options} value={selected} />
      </div>
    </Accordion>
  );
};
